import { BranchLimitsHolder } from "@tlc/ls2pac/components/BranchLimits";
import { TLCEventManager } from "../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../js/main/constants";
import { LibraryThing } from "./widget/LibraryThingWidget";
import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { LocationConfigurationHolder } from "@tlc/ls2pac/components/LocationConfiguration";

export const ApplicationData = (function ( $ ) {

	var locationConfiguration;

	LocationConfigurationHolder.subscribe((data) => {
		locationConfiguration = data;
	});

	TLCEventManager.addListener( LS2PAC_CONSTANTS.Events.onGetGlobalConfigurationResponse, function ( event ) {
		myData.globalConfiguration = event.data;
	} );

	TLCEventManager.addListener( LS2PAC_CONSTANTS.Events.onGetSupportFunctionalityResponse, function ( event ) {
		myData.supportedFunctionality = event.data;
		//TLCLogger.log("appData:supportedFunctionality:", myData.supportedFunctionality);
	} );

	// TODO replace with StationLocationHolder and remove StationLocationClientManager
	TLCEventManager.addListener( LS2PAC_CONSTANTS.Events.onGetCurrentBranchResponse, function ( event ) {
		myData.currentBranch = event.branch;
		TLCLogger.log( "appData:currentBranch:", myData.currentBranch, event, ApplicationData.getBranchToUseForAvailability() );
		if( event.branch ) {
			myData.currentBranchId = event.branch.identifier;
		}

	} );

	

	TLCEventManager.addListener( LS2PAC_CONSTANTS.Events.onLogoutResponse, function ( event ) {
		ApplicationData.branchLimitsUtil.setLimitedBranches( [] );
		//TLCLogger.log("appData:currentUser:", myData.currentUser, ApplicationData.getCurrentUser());
	} );

	TLCEventManager.addListener( LS2PAC_CONSTANTS.Events.onGetLanguageResponse, function ( event ) {
		myData.language = event.data;
		//TLCLogger.log("appData:language:", myData.language);

		setAdvancedSearchFields();
	} );

	//The cat ate my gymsuit

	var currResultsView;
	var currentBackEvent;

	var myData = {
		getCurrentUser:                function () {
			return myData.currentUser;
		},
		getUserDefaultPickupBranch:    function () {
			var branch = null;
			if( myData.currentUser !== undefined && myData.currentUser !== null ) {
				//use defaultRequestPickupBranch first, if thats not set use issuing
				if( myData.currentUser.defaultRequestPickupBranch ) {
					branch = myData.currentUser.defaultRequestPickupBranch;
				}
				else if( myData.currentUser.issuingBranch ) {
					branch = myData.currentUser.issuingBranch;
				}
			}
			return branch;
		},
		getBranchToUseForAvailability: function ( ignoreUsersBranch ) {
			var branch = null;

			//is station location is set use it
			if( myData.currentBranchId ) {
				branch = myData.currentBranchId;
				return branch;
			}
			//is there only one branch?
			var oneBranch = ApplicationData.branchLimitsUtil.getBranchIfThereIsOnlyOne();
			if( oneBranch != null ) {
				return oneBranch;
			}
			//but
			if( ApplicationData.locationConfiguration.useUsersBranchForAvailability() == false || ignoreUsersBranch ) {
				return null;
			}
			//and finally
			return ApplicationData.getUserDefaultPickupBranch();
		},
		getDefaultResultsView:         function () {
			return "listView";
		},
		setCurrentResultsView:         function ( view ) {
			currResultsView = view;
		},
		getCurrentResultsView:         function () {
			if( !currResultsView ) {
				currResultsView = ApplicationData.getDefaultResultsView();
			}
			return currResultsView;
		},
		getDefaultBackEvent:           function () {
			return LS2PAC_CONSTANTS.Events.onBackToSearch;
		},
		setCurrentBackEvent:           function ( backEvent ) {
			currentBackEvent = backEvent;
		},
		getCurrentBackEvent:           function () {
			if( !currentBackEvent ) {
				currentBackEvent = ApplicationData.getDefaultBackEvent();
			}
			return currentBackEvent;
		},
		getSearchTypeHash:             function ( type ) {
			return myData.SearchTypeHash[type];
		},
		locationConfiguration:         {
			getData: function(){
				return locationConfiguration;
			},
			showBranchLimitControl:                   function () {
				var onlyOneBranch = ApplicationData.branchLimitsUtil.getBranchIfThereIsOnlyOne();
				return !this.isConfigLimitedToOneBranch() && !onlyOneBranch;
			},
			showAudienceControl:                      function () {
				return locationConfiguration.pacSettings.displaySettings.displayAudienceCharacteristicsFilter;
			},
			isConfigLimitedToOneBranch:               function () {
				if( locationConfiguration.filterBranches ) {
					var locations = $.grep( locationConfiguration.filterBranches, function ( location ) {
						return location.shared == false;
					} );
					return (locations.length == 1);
				}
				return false;
			},
			isLimitedToOneBranch:                     function () {
				return (ApplicationData.branchLimitsUtil.getLimitedBranches().length == 1);
			},
			isLocationKnown:                          function () {
				if( ApplicationData.getBranchToUseForAvailability() || ApplicationData.locationConfiguration.isLimitedToOneBranch() ) {
					return true;
				}
				return false;
			},
			getLibraryName:                           function () {
				return locationConfiguration.libraryName;
			},
			isLDAPEnabled:                            function () {
				if( !myData.globalConfiguration.ldapEnabled ) {
					return this.isSSOEnabled();
				}
				return myData.globalConfiguration.ldapEnabled;
			},
      isObrEnabled:                     				function () {
        return myData.globalConfiguration.obrEnabled && locationConfiguration.pacSettings.obrEnabled;
      },
			isGoogleOauthEnabled:                     function () {
        return myData.globalConfiguration.googleOauthEnabled && locationConfiguration.pacSettings.googleSSOEnabled;
      },
			isSSOEnabled:                             function () {
				return myData.globalConfiguration.casEnabled;
			},
			getSSOsettings:                           function () {
				return myData.globalConfiguration.casSettings;
			},
			showDisplayCase:                          function () {
				// TODO Fix this once Display Case is implemented
				TLCLogger.log( "############ WARNING ###########", "locationConfiguration.pacSettings.displaySettings.showDisplayCase is forced to false because its not implemented" );
				return false;//locationConfiguration.pacSettings.displaySettings.showDisplayCase;
			},
			showSmartGraphic:                         function () {
				// TODO Fix this once Smart Graphic is implemented
				TLCLogger.log( "############ WARNING ###########", "locationConfiguration.pacSettings.displaySettings.showSmartGraphic is forced to false because its not implemented" );
				return false;//locationConfiguration.pacSettings.displaySettings.showSmartGraphic;
			},
			showQuickInfoFirst:                       function () {
				return (ApplicationData.locationConfiguration.showDisplayCase() === false && ApplicationData.locationConfiguration.showSmartGraphic() === false) ? true : false;
			},
			showMarcRecordView:                       function () {
				return locationConfiguration.pacSettings.displaySettings.showMarcRecordView;
			},
			showResetPINLink:                       function () {
				return locationConfiguration.pacSettings.displaySettings.showResetPINLink;
			},
			displayGuardianLogin:                     function () {
				return locationConfiguration.pacSettings.displaySettings.displayGuardianLogin;
			},
			isVirtualShelfEnabled:                    function () {
				return locationConfiguration.pacSettings.displaySettings.displayVirtualShelf;
			},
			showMoreInfoView:                         function () {
				return LibraryThing.hasMoreInfoTab();
				// return locationConfiguration.pacSettings.displaySettings.showMoreInfoView;
			},
			showUserReviewsView:                      function () {
				return locationConfiguration.pacSettings.displaySettings.showUserReviewsView;
			},
			showEditorialReviewsView:                 function () {

				return LibraryThing.hasEditorialReviews();
				// return locationConfiguration.pacSettings.displaySettings.showEditorialReviewsView;
			},
			showBorrowerReviewsView:                  function () {
				return locationConfiguration.pacSettings.displaySettings.showUserReviewsView;
			},
			showReviews:                              function () {
				if(locationConfiguration.pacSettings.displaySettings.showUserReviewsView === true) {
					return true;
				}

                return LibraryThing.hasEditorialReviews();
				// if( locationConfiguration.pacSettings.displaySettings.showUserReviewsView == true ||
				// 	locationConfiguration.pacSettings.displaySettings.showEditorialReviewsView == true ) {
				// 	return true;
				// }
			},
			showTotalCheckouts:                       function () {
				return locationConfiguration.pacSettings.displaySettings.showTotalCheckouts;
			},
			showTotalHolds:                           function () {
				return locationConfiguration.pacSettings.displaySettings.showTotalHolds;
			},
      showDependentBorrowers:                           function () {
        return locationConfiguration.pacSettings.displaySettings.showDependentBorrowers;
      },
			shouldGetRealTimeHostInfo:                function () {
				return (locationConfiguration.pacSettings.displaySettings.showTotalCheckouts == true ||
				locationConfiguration.pacSettings.displaySettings.showTotalHolds == true);
			},
			showBrowse:                               function () {
				// TODO Fix this Browse is implemented
				TLCLogger.log( "############ WARNING ###########", "locationConfiguration.pacSettings.displaySettings.showBrowse is forced to false because its not implemented" );
				return false;//locationConfiguration.pacSettings.displaySettings.showBrowse;
			},
			isDisplayCopiesFirst:                     function () {
				return locationConfiguration.pacSettings.displaySettings.displayCopiesFirst;
			},
			getAllowHolds:                            function () {
				return {
					item:          locationConfiguration.pacSettings.userActionSettings.allowItemLevelHolds,
					title:         locationConfiguration.pacSettings.userActionSettings.allowTitleLevelHolds,
					onShelf:       locationConfiguration.pacSettings.userActionSettings.allowOnShelfHolds,
					restrictTitle: locationConfiguration.pacSettings.userActionSettings.restrictTitleLevelHolds
				};
			},
			getAllowBookings:                         function () {
				return locationConfiguration.pacSettings.bookingsSettings.allowBookings;
			},
			getAllowRenewals:                         function () {
				return locationConfiguration.pacSettings.userActionSettings.allowRenewals;
			},
			getBookingsBranchIdentifier:              function () {
				return locationConfiguration.pacSettings.bookingsSettings.bookingsBranchIdentifier;
			},
			getShowMap:                               function () {
				// TODO Fix this once maps are implemented
				//TLCLogger.log("############ WARNING ###########", "locationConfiguration.pacSettings.displaySettings.showMapView is forced to false because its not implemented");
				return false;//locationConfiguration.pacSettings.displaySettings.showMapView;
			},
			getUseDummyJackets:                       function () {
				return locationConfiguration.pacSettings.displaySettings.useDummyJackets;
			},
			getUseForgotPasswordLink:                 function () {
				return myData.globalConfiguration.useForgotPasswordLink;
			},
			getMaterialDescriptionViewConfigItems:    function () {
				return locationConfiguration.pacSettings.materialDescriptionViewConfigItems;
			},
			allowTagging:                             function () {
				return locationConfiguration.pacSettings.userActionSettings.allowTagging;
			},
			getAdditionalLinkBehavior:                function () {
				if( locationConfiguration.pacSettings.displaySettings.openLinksInNewTab ) {
					return "_blank";
				}
				return "";
			},
			getAdditionalLinks:                       function () {
				var additionalLinks = [];
				if( locationConfiguration.pacSettings.additionalLink1 !== null &&
					locationConfiguration.pacSettings.additionalLink1.additionalLinkURL != "" ) {
					additionalLinks.push( {
						text: locationConfiguration.pacSettings.additionalLink1.additionalLinkText,
						url:  locationConfiguration.pacSettings.additionalLink1.additionalLinkURL
					} );
				}
				if( locationConfiguration.pacSettings.additionalLink2 !== null &&
					locationConfiguration.pacSettings.additionalLink2.additionalLinkURL != "" ) {
					additionalLinks.push( {
						text: locationConfiguration.pacSettings.additionalLink2.additionalLinkText,
						url:  locationConfiguration.pacSettings.additionalLink2.additionalLinkURL
					} );
				}
				if( locationConfiguration.pacSettings.additionalLink3 !== null &&
					locationConfiguration.pacSettings.additionalLink3.additionalLinkURL != "" ) {
					additionalLinks.push( {
						text: locationConfiguration.pacSettings.additionalLink3.additionalLinkText,
						url:  locationConfiguration.pacSettings.additionalLink3.additionalLinkURL
					} );
				}
				if( locationConfiguration.pacSettings.additionalLink4 !== null &&
					locationConfiguration.pacSettings.additionalLink4.additionalLinkURL != "" ) {
					additionalLinks.push( {
						text: locationConfiguration.pacSettings.additionalLink4.additionalLinkText,
						url:  locationConfiguration.pacSettings.additionalLink4.additionalLinkURL
					} );
				}
				if( locationConfiguration.pacSettings.additionalLink5 !== null &&
					locationConfiguration.pacSettings.additionalLink5.additionalLinkURL != "" ) {
					additionalLinks.push( {
						text: locationConfiguration.pacSettings.additionalLink5.additionalLinkText,
						url:  locationConfiguration.pacSettings.additionalLink5.additionalLinkURL
					} );
				}
				return additionalLinks;
			},
			showRelatedTab:                           function () {

				if(locationConfiguration.pacSettings.noveListSettings.useNoveList) {
					return true;
				}
				return LibraryThing.hasRelatedTab();

				// if( locationConfiguration.pacSettings.libraryThingSettings.useLibraryThingWidget ||
				// 	locationConfiguration.pacSettings.noveListSettings.useNoveList ) {
				// 	return true;
				// }
				// return false;
			},
			// useLibraryThingWidget:                    function () {
			// 	return locationConfiguration.pacSettings.libraryThingSettings.useLibraryThingWidget;
			// },
			useNoveListWidget:                        function () {
				return locationConfiguration.pacSettings.noveListSettings.useNoveList;
			},
			// getLibraryThingSettings:                  function () {
			// 	return locationConfiguration.pacSettings.libraryThingSettings;
			// },
			getNoveListSettings:                      function () {
				return locationConfiguration.pacSettings.noveListSettings;
			},
			isEcommerceEnabled:                       function () {
				return locationConfiguration.pacSettings.ecommerceEnabled;
			},
			getCarlXWebEcommerceEnabled:              function () {
				return myData.globalConfiguration.carlXWebEcommerceSettings.enabled;
			},
			getCarlXWebEcommerceUrl:                  function () {
				return myData.globalConfiguration.carlXWebEcommerceSettings.url;
			},
			getCarlXWebEcommerceButtonText:           function () {
				return myData.globalConfiguration.carlXWebEcommerceSettings.buttonText;
			},
			getShowDueDateForItems:                   function () {
				return myData.globalConfiguration.globalSettings.showDueDateForItems;
			},
			getSharingEnabled:                        function () {
				return myData.globalConfiguration.sharingEnabled;
			},
			getPersonalInformationIsHidden:           function () {
				return myData.globalConfiguration.globalSettings.hidePersonalInformation;
				//ApplicationData.globalConfiguration.hidePersonalInformation
			},
			getPinEditable:                           function () {
				return myData.globalConfiguration.hostInformation.pinEditable;
			},
			getUsePin:                                function () {
				return myData.globalConfiguration.hostInformation.usePin && !myData.locationConfiguration.isLDAPEnabled() && !myData.locationConfiguration.isADFSEnabled();
			},
			getEmailEditable:                         function () {
				return myData.globalConfiguration.hostInformation.emailEditable;
			},
			getAddressEditable:                       function () {
				return myData.globalConfiguration.hostInformation.addressEditable;
			},
			getPhoneNumberEditable:                   function () {
				return myData.globalConfiguration.hostInformation.phoneNumberEditable;
			},
			getUseAlternateTimeoutPage:               function () {
				return locationConfiguration.pacSettings.useAlternateTimeoutPage;
			},
			getAlternateTimeoutPageUrl:               function () {
				return locationConfiguration.pacSettings.alternateTimeoutPageUrl;

			},
			showRegisterLink:                         function () {
				return false; //TODO remove this once OBR is implemented
				//return locationConfiguration.pacSettings.obrEnabled;
			},
			getHelpUrl:                               function () {
				if( locationConfiguration.helpSettings.localHelpURL.length > 0 ) {
					return locationConfiguration.helpSettings.localHelpURL;
				}
				//TODO HMFEDYMOH
				return locationConfiguration.helpSettings.helpURLBase + window.currentVersion.replace(/\./g, "_") + "/UserApp/LS2PAC.htm";
			},
			getAlternateLogoLink:                     function () {
				return locationConfiguration.pacSettings.displaySettings.alternateLinkURL;
			},
			getAlternateLogoText:                     function () {
				return locationConfiguration.pacSettings.displaySettings.alternateLinkText;
			},
			getMainLogoUrl:                           function () {
				return locationConfiguration.pacSettings.displaySettings.mainPageLogoImageId;
			},
			setMainLogoUrl:                           function ( imageId ) {
				locationConfiguration.pacSettings.displaySettings.mainPageLogoImageId = imageId;
			},
			isOverDriveEnabled:                       function () {
				return locationConfiguration.pacSettings.useOverDrive;
			},
			isBakerAndTaylorEnabled:                  function () {
				return locationConfiguration.pacSettings.useBakerAndTaylor;
			},
			isTeachingBooksEnabled:                   function () {
				return locationConfiguration.pacSettings.useTeachingBooks;
			},
			isMackinEnabled:                  function () {
				return locationConfiguration.pacSettings.useMackin;
			},
			useThirdPartyEResourceAvailability:       function () {
				return ApplicationData.locationConfiguration.isOverDriveEnabled()
					|| ApplicationData.locationConfiguration.isBakerAndTaylorEnabled()
					|| ApplicationData.locationConfiguration.isMackinEnabled();
			},
			isEbscoEnabled:                           function () {
				return locationConfiguration.pacSettings.useEbsco;
			},
			isNewsBankEnabled:                        function () {
				return locationConfiguration.pacSettings.useNewsBank;
			},
			isBritannicaEnabled:                      function () {
				return locationConfiguration.pacSettings.useBritannica;
			},
			isGaleEnabled:                            function () {
				return locationConfiguration.pacSettings.useGale;
			},
			isWorldBookEnabled:                       function () {
				return locationConfiguration.pacSettings.useWorldBook;
			},
			getWorldBookDatabases:                    function () {
				return locationConfiguration.pacSettings.worldBookDbOptions;
			},
			isReservesEnabled:                        function () {
				return locationConfiguration.pacSettings.reservesEnabled;
			},
			isDisplaySelectPickupLocation:            function () {
				return locationConfiguration.pacSettings.displaySettings.displaySelectPickupLocation;
			},
			areReadingLevelsEnabled:                  function () {
				return ApplicationData.locationConfiguration.isLexileEnabled()
					|| ApplicationData.locationConfiguration.isAcceleratedReaderEnabled();
			},
			isReadingLevelEnabledInSearchResults:     function () {
				return locationConfiguration.pacSettings.displaySettings.displayReadingLevelInSearchResults;
			},
			displayReadingLevelKidsSearchResults:     function () {
				return locationConfiguration.pacSettings.kidsSettings.displaySettings.displayReadingLevelInKidsSearchResults;
			},
			isLexileEnabled:                          function () {
				return locationConfiguration.pacSettings.lexileEnabled;
			},
			isAcceleratedReaderEnabled:               function () {
				return locationConfiguration.pacSettings.acceleratedReaderEnabled;
			},
			isQuizNumberEnabled:                      function () {
				return locationConfiguration.pacSettings.acceleratedReaderShowQuizNumber;
			},
			getGoogleAnalyticsSettings:               function () {
				return locationConfiguration.pacSettings.googleAnalyticsSettings;
			},
			isStationLocationSet:                     function () {
				return (myData.currentBranchId != undefined);
			},
			isDownloadNowOverrideSet:                 function () {
				return locationConfiguration.pacSettings.overrideDownloadNowStationLocation;
			},
			isRememberMeDisabled:                     function () {
				return !locationConfiguration.pacSettings.displaySettings.showRememberMe;
			},
			useUsersBranchForAvailability:            function () {
				var useUsersBranchForAvailability = locationConfiguration.pacSettings.userActionSettings.useUsersBranchForAvailability;

				return (useUsersBranchForAvailability === undefined) ? true : useUsersBranchForAvailability;
			},
			kidsLandingPage:                          function () {
				return locationConfiguration.pacSettings.kidsSettings.landingPage;
			},
			isKidsOverrideDownloadNowStationLocation: function () {
				return locationConfiguration.pacSettings.kidsSettings.overrideDownloadNowStationLocation;
			},
			isKidsEnableEResourceAvailability:        function () {
				return locationConfiguration.pacSettings.kidsSettings.enableEResourceAvailability;
			},
			isKidsEnableEResourceHoldsCheckouts:      function () {
				return locationConfiguration.pacSettings.kidsSettings.enableEResourceAvailability &&
					locationConfiguration.pacSettings.kidsSettings.enableEResourceHoldsCheckouts;
			},
			isADFSEnabled:                            function () {
				return myData.globalConfiguration.adfsEnabled;
			},
			useADFSRedirect:                            function () {
				return myData.globalConfiguration.adfsSettings.useRedirect;
			},
			getADFSLoginUrl:                          function () {
				var hash = location.hash.substring(1).replace(new RegExp("%22", 'g'), '"');

				return myData.globalConfiguration.adfsSettings.loginUrl
					+ "?path=" + encodeURIComponent(location.pathname)
					+ "&search=" + encodeURIComponent(location.search)
					+ "&hash=" + encodeURIComponent(hash);
			},
			getADFSTimeoutUrl:                        function () {
				return myData.globalConfiguration.adfsSettings.timeoutUrl;
			},
			getADFSLogoutUrl:                         function () {
				return myData.globalConfiguration.adfsSettings.logoutUrl;
			}
		},
		branchLimitsUtil:              {
			getLimitsWithoutHidden:        function () {
				const {branchLimits} = myData.branchLimits;
				return branchLimits.filter((branch) => branch.hidden === false);
			},
			setLimitedBranches:            function ( limitedBranchIds ) {
				BranchLimitsHolder.setSelectedBranchLimits(limitedBranchIds);
			},
			getIsLimiting:                 function () {
				const {branchLimits, isConfigLimited} = myData.branchLimits;
				const selectedBranches = branchLimits.filter((branch) => branch.hidden === false && branch.selected === true);
				return isConfigLimited || selectedBranches.length > 0;
			},
			getIsConfigLimiting:           function () {
				return myData.branchLimits.isConfigLimited;
			},
			/**
			 *
			 * @return {Array.<string>}
			 */
			getLimitedBranches:            function () {
				const limits = myData.branchLimits.branchLimits
					.filter((branch) => branch.hidden === false && branch.selected === true)
					.map((branch) => branch.identifier);

				if(limits.length > 0) {
					return limits;
				}

				const {filterBranches = []} = locationConfiguration;

				return filterBranches.filter((branch) => branch.shared == false).map((branch) => branch.identifier);
			},
			getBranchNameById:             function ( id ) {
				const {branchLimits} = myData.branchLimits;
				const match = branchLimits.find((branch) => branch.identifier === id.toString());
				if(match){
					return match.displayName;
				}
				return "";
			},
			getCurrentBranchIfNotLimited:  function ( ignoreUsersBranch ) {
				const branchToUseForAvailability = ApplicationData.getBranchToUseForAvailability( ignoreUsersBranch );
				if(!branchToUseForAvailability) {
					return null;
				}

				const limitedBranches = ApplicationData.branchLimitsUtil.getLimitedBranches();

				if(limitedBranches.length === 0) {
					return branchToUseForAvailability;
				}

				return limitedBranches.includes(branchToUseForAvailability) ? branchToUseForAvailability : null;
			},
			getDisplayInPickupLocationIds: function () {
				const {branchLimits} = myData.branchLimits;
				return branchLimits.filter((branch) => branch.displayInPickupLocation).map((branch) => branch.identifier);
			},
			getDisplayInCopiesIds:         function () {
				const {branchLimits} = myData.branchLimits;
				return branchLimits.filter((branch) => branch.displayInCopies).map((branch) => branch.identifier);
			},
			getDisplayInBranchLimitsIds:   function () {
				const {branchLimits} = myData.branchLimits;
				return branchLimits.filter((branch) => branch.hidden === false && branch.displayInBranchLimits).map((branch) => branch.identifier);
			},
			getBranchIfThereIsOnlyOne:     function () {
				const {branchLimits} = myData.branchLimits;

				const visibleBranchIds = branchLimits
					.filter((branch) => branch.hidden === false && branch.displayInCopies)
					.map((branch) => branch.identifier);
				if(visibleBranchIds.length === 1) {
					return visibleBranchIds[0];
				}
				return null;
			}
		}
	};

	AccountHolder.subscribe(({user}) => {
		myData.currentUser = user;
	});
	BranchLimitsHolder.subscribe((event) => {
		myData.branchLimits = event;
	})

	myData.SearchTypeHash = {};
	myData.SearchTypeHash["default"] = {
		type:   "default",
		prefix: ""
	};
	myData.SearchTypeHash["authorsuggestion"] = {
		type:   "facets.author",
		prefix: "facets.author:"
	};
	myData.SearchTypeHash["author"] = {
		type:   "author",
		prefix: "au:"
	};
	myData.SearchTypeHash["title"] = {
		type:   "title",
		prefix: "ti:"
	};
	myData.SearchTypeHash["subject"] = {
		type:   "subject",
		prefix: "su:"
	};
	myData.SearchTypeHash["seriestitle"] = {
		type:   "seriestitle",
		prefix: "se:"
	};
	myData.SearchTypeHash["isbn"] = {
		type:   "isbn",
		prefix: "isbn:"
	};
	myData.SearchTypeHash["tag"] = {
		type:   "tag",
		prefix: "tag:"
	};
	myData.SearchTypeHash["rss"] = {
		type:   "rss",
		prefix: "rss:"
	};
	myData.SearchTypeHash["callNumber"] = {
		type:   "CallNumber",
		prefix: "cn:"
	};

	var setAdvancedSearchFields = function () {

		var searchTypes = {
			BeginsWith:  {
				label: ApplicationData.language.beginsWith,
				key:   LS2PAC_CONSTANTS.searchTypeKeys.BeginsWith
			},
			Contains:    {
				label: ApplicationData.language.contains,
				key:   LS2PAC_CONSTANTS.searchTypeKeys.Contains
			},
			ExactMatch:  {
				label: ApplicationData.language.exactlyMatches,
				key:   LS2PAC_CONSTANTS.searchTypeKeys.ExactMatch
			},
			NotContains: {
				label: ApplicationData.language.doesNotContain,
				key:   LS2PAC_CONSTANTS.searchTypeKeys.NotContains
			}
		};

		myData.advancedSearchFields = [
			{
				name:        ApplicationData.language.advancedSearch_anyField,
				key:         LS2PAC_CONSTANTS.searchFieldKeys.AnyField,
				searchTypes: [
					{
						type: searchTypes.Contains
					},
					{
						type: searchTypes.NotContains
					}
				]
			},
			{
				name:        ApplicationData.language.advancedSearch_title,
				key:         LS2PAC_CONSTANTS.searchFieldKeys.Title,
				searchTypes: [
					{
						type:  searchTypes.BeginsWith,
						value: 'titlekeyword'
					},
					{
						type:             searchTypes.Contains,
						value:            'title',
						defaultSelection: true
					},
					{
						type:  searchTypes.ExactMatch,
						value: 'titlekeyword'
					},
					{
						type:  searchTypes.NotContains,
						value: 'title'
					}
				]
			},
			{
				name:        ApplicationData.language.advancedSearch_author,
				key:         LS2PAC_CONSTANTS.searchFieldKeys.Author,
				searchTypes: [
					{
						type:  searchTypes.BeginsWith,
						value: 'authorkeyword'
					},
					{
						type:             searchTypes.Contains,
						value:            'author',
						defaultSelection: true
					},
					{
						type:  searchTypes.ExactMatch,
						value: 'authorkeyword'
					},
					{
						type:  searchTypes.NotContains,
						value: 'author'
					}
				]
			},
			{
				name:        ApplicationData.language.advancedSearch_series,
				key:         LS2PAC_CONSTANTS.searchFieldKeys.Series,
				searchTypes: [
					{
						type:  searchTypes.BeginsWith,
						value: 'seriestitle'
					},
					{
						type:             searchTypes.Contains,
						value:            'seriestitle',
						defaultSelection: true
					},
					{
						type:  searchTypes.ExactMatch,
						value: 'seriestitle'
					},
					{
						type:  searchTypes.NotContains,
						value: 'seriestitle'
					}
				]
			},
			{
				name:        ApplicationData.language.advancedSearch_subject,
				key:         LS2PAC_CONSTANTS.searchFieldKeys.Subject,
				searchTypes: [
					{
						type:  searchTypes.BeginsWith,
						value: 'subjectkeyword'
					},
					{
						type:             searchTypes.Contains,
						value:            'subject',
						defaultSelection: true
					},
					{
						type:  searchTypes.ExactMatch,
						value: 'subjectkeyword'
					},
					{
						type:  searchTypes.NotContains,
						value: 'subject'
					}
				]
			},
			{
				name:        ApplicationData.language.advancedSearch_note,
				key:         LS2PAC_CONSTANTS.searchFieldKeys.Note,
				searchTypes: [
					{
						type:  searchTypes.Contains,
						value: 'note'
					},
					{
						type:  searchTypes.NotContains,
						value: 'note'
					}
				]
			},
			{
				name:             ApplicationData.language.advancedSearch_tag,
				key:              LS2PAC_CONSTANTS.searchFieldKeys.Tag,
				localConfigCheck: ApplicationData.locationConfiguration.allowTagging,
				searchTypes:      [
					{
						type:  searchTypes.BeginsWith,
						value: 'tagkeyword'
					},
					{
						type:             searchTypes.Contains,
						value:            'tag',
						defaultSelection: true
					},
					{
						type:             searchTypes.ExactMatch,
						value:            'tagkeyword'
					},
					{
						type:             searchTypes.NotContains,
						value:            'tag',
					}
				]
			},
			{
				name:        ApplicationData.language.advancedSearch_isbn,
				key:         LS2PAC_CONSTANTS.searchFieldKeys.ISBN,
				searchTypes: [
					{
						type:  searchTypes.BeginsWith,
						value: 'isbn'
					},
					{
						type:             searchTypes.ExactMatch,
						value:            'isbn',
						defaultSelection: true
					}
				]
			},
			{
				name:        ApplicationData.language.advancedSearch_issn,
				key:         LS2PAC_CONSTANTS.searchFieldKeys.ISSN,
				searchTypes: [
					{
						type:  searchTypes.BeginsWith,
						value: 'issn'
					},
					{
						type:             searchTypes.ExactMatch,
						value:            'issn',
						defaultSelection: true
					}
				]
			},
			{
				name:        ApplicationData.language.advancedSearch_upc,
				key:         LS2PAC_CONSTANTS.searchFieldKeys.UPC,
				searchTypes: [
					{
						type:  searchTypes.BeginsWith,
						value: 'upc'
					},
					{
						type:             searchTypes.ExactMatch,
						value:            'upc',
						defaultSelection: true
					}
				]
			},
			{
				name:        ApplicationData.language.localCallNumber,
				key:         LS2PAC_CONSTANTS.searchFieldKeys.CallNumber,
				searchTypes: [
					{
						type:             searchTypes.BeginsWith,
						value:            'CallNumber',
						defaultSelection: true
					}
				]
			}
		];
	};

	return myData;

})( jQuery );
